import React from 'react';

import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

import classes from './LandingHeader.module.scss';
import {
  CHALLENGE_STATUS,
  ChallengeStatusType,
} from '../../../constants/challengeStatus';
import { ChallengeImportantDatesInfo } from '../../../interfaces/ChallengeInfo';
import { localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { getFormattedDateInTz } from '../../../../shared/utils/timezoneUtils/getFormattedDateInTz';
import { TimerBlock } from './TimerBlock/TimerBlock';
import { getChallengeTimerParams } from './utils/getChallengeTimerParams';

type LandingHeaderProps = {
  challengeStatus: ChallengeStatusType;
  importantDates: ChallengeImportantDatesInfo;
};

const LandingHeader = ({ challengeStatus, importantDates }: LandingHeaderProps) => {
  const { timerEpoch, description } = getChallengeTimerParams(
    challengeStatus,
    importantDates,
  );

  if (challengeStatus === CHALLENGE_STATUS.FINISHED) {
    if (!importantDates.endDate || !importantDates.timeZone) {
      return null;
    }

    return (
      <div className={classes.finishedLabel}>
        <WarningRoundedIcon color="warning" />
        <p>
          The Challenge is finished on&nbsp;
          {getFormattedDateInTz(
            importantDates.endDate,
            importantDates.timeZone,
            localDataFormat,
          )}
        </p>
      </div>
    );
  }

  if (!timerEpoch || !description) {
    return null;
  }

  return <TimerBlock expirationEpoch={timerEpoch} description={description} />;
};

export { LandingHeader };
